import { useContext, useState, useEffect } from 'react';
import PageContext from './PageContext';
import { HttpContext } from '../../api-services/HttpService';
import { useSelector } from "react-redux";
import ApiRequestButton from './ApiRequestButton';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import CCOffcanvas from './CCOffcanvas.tsx';
import ButtonComponent from './ButtonComponent.jsx';

const RemoveConsortiumMasterCompany = () => {
    // get page context from parent
    const {
        editModal, 
        setEditModal, 
        editCompany, 
        snackbarAlert, 
        getConsortiumData, 
    } = useContext(PageContext); 
    // get HTTP context from parent
    const {
        POST, 
    } = useContext(HttpContext); 
    // get global redux state 
    const consortiumId = useSelector((state) => state.consortiumId);
    // initialize state 
    const [value, setValue] = useState(false);

    // useEffect to run on modal render
    useEffect(() => {
        // default value state 
        setValue(value => value = false); 
    }, [editModal]); 

    // event handler for submit button click 
    const onSubmitClick = () => {
        return new Promise((resolve, reject) => {
            if (!value) {
                snackbarAlert(true, 'Check Remove ' + process.env.REACT_APP_MASTER_COMPANY_ID_TAG, 'error');  
                reject();
                return; 
            }
            // use POST function to make request 
            POST('/consortium/removeConsortiumMasterCompany', {
                mastercompanyid: editCompany['mastercompanyid'],
                consortiumid: consortiumId, 
            }).then(res => {
                console.log(res); 
                // default value state 
                setValue(value => value = false); 
                // hide modal on success
                setEditModal(editModal => editModal = false); 
                // show snackbar on success
                snackbarAlert(true, 'Successfully removed ' + process.env.REACT_APP_MASTER_COMPANY_ID_TAG + '.', 'success');
                // refresh data on success
                return getConsortiumData();  
            }).then(res => {
                console.log(res); 
                // resolve on success 
                resolve(res); 
            }).catch(err => {
                // show snackbar on error
                snackbarAlert(true, 'Error removing ' + process.env.REACT_APP_MASTER_COMPANY_ID_TAG + '.', 'error');
                // reject on error
                reject(err); 
            });             
        }); 
        
    }

    // useEffect to run on modal trigger
    useEffect(() => {
        setValue(value => value = false); 
    }, [editModal]); 

    return(
        <> 
            <CCOffcanvas
                    title={`Remove ${process.env.REACT_APP_MASTER_COMPANY_ID_TAG}: ${editCompany['mastercompanyid']}`}
                    show={editModal}
                    onCanvasClose={()=>setEditModal(editModal => editModal = false)}
                    bodyCssClassName="offcanvas-body bg-white p-3"
                    offCanvasClassName="offcanvas-parent-card-40"
                >
                    <div className="d-flex flex-column h-100">
                        <div className="d-flex flex-column gap-3 flex-grow-1 overflow-scroll">
                        <FormControlLabel
                                value="end"
                                control={<Checkbox
                                    sx={{
                                        color: '#ff0f0f',
                                        '&.Mui-checked': {
                                        color: '#ff0f0f',
                                        },
                                    }} 
                                    />}
                                label={'Remove ' + process.env.REACT_APP_MASTER_COMPANY_ID_TAG + ': ' + editCompany['mastercompanyid'] + ' from Consortium ID: ' + consortiumId}
                                labelPlacement="end"
                                sx={{
                                    color: 'red',
                                    fontSize: '1rem'
                                }}
                                checked={value}
                                onChange={(e)=>{setValue(value => value = e.target.checked)}}
                            />
                        </div>
                        <div
                            className="d-flex justify-content-end p-3 w-100 offcanvas-footer z-2" style={{height: '65px'}}
                        >
                            <ButtonComponent tag={"Cancel"}
                                border={'#fcd800 1px solid'} background={'#fff'} color={'#001317'}
                                onButtonClick={()=>setEditModal(editModal => editModal = false)}
                            />
                            {/* button to submit company entitlement edit */}
                            <ApiRequestButton tag='Remove' onButtonClick={onSubmitClick} />
                        </div>
                    </div>
                </CCOffcanvas>
        </>
    );
}

export default RemoveConsortiumMasterCompany; 